import { Language } from './enums/language.enum';

export const SEARCH_QUERY_PARAM = 'q';
export const QUERY_PARAM_ARRAY_DELIMITER = '^';
export const INPUT_MEDIA_ACCEPT_TYPES = '.jpg,.jpeg,.png,.webp,.svg,.tiff,.gif';
export const DEFAULT_ERROR_TEXT = 'Щось пішло не так. Будь ласка, спробуйте пізніше';
export const IS_EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]+([.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,3}$/;
export const DEFAULT_PHONE_NUMBER_VALUE = '+380';
export const MINIMAL_ORDER_COST: number = 300;
export const DEFAULT_LANG = Language.RU;
export const STATUS_CODES = {
  maintenance: 503,
  tooManyRequests: 429,
};
export const OAUTH_SUCCESS_STORAGE_KEY = 'oauth-success';
export const PICKUP_ROUTE_URL = `https://www.google.com.ua/maps/dir/?api=1&destination=Poltavska+St,+64%D0%B2,+Irpin,+Kyivs%27ka+oblast,+08200`;
export const PHONE_NUMBER_MASK = '+00 (000) 000-00-00-00000000000';
export const OTP_LENGTH = 4;
export const MANAGER_PHONES = ['+380678811962', '+380933444342'];

export const RU_ROUTE_PREFIX = '';
export const UA_ROUTE_PREFIX = 'ua';
export const BLOG_ROUTE_PREFIX = 'blog';
